"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var analytics_1 = require("@cian/analytics");
var authentication_widget_1 = require("@cian/authentication-widget");
var EVENT_TWO_FACTOR_MAPPER = (_a = {},
    _a[authentication_widget_1.ETwoFactorType.Sms] = 'phone_',
    _a[authentication_widget_1.ETwoFactorType.Email] = 'email_',
    _a);
/**
 * показ попапа авторизации
 */
function trackShowAuthPopup() {
    analytics_1.ca('event', {
        name: 'oldevent',
        category: 'AuthBlock',
        action: 'show',
        label: '',
    });
}
exports.trackShowAuthPopup = trackShowAuthPopup;
/**
 * скрытие попапа авторизации
 */
function trackCloseAuthPopup() {
    analytics_1.ca('event', {
        name: 'oldevent',
        category: 'AuthBlock',
        action: 'close',
        label: '',
    });
}
exports.trackCloseAuthPopup = trackCloseAuthPopup;
/**
 * Успешная авторизация
 */
function trackAuthenticateSuccess(socialType) {
    analytics_1.ca('event', {
        name: 'oldevent',
        category: 'Authorization',
        action: 'success',
        label: socialType || '',
    });
}
exports.trackAuthenticateSuccess = trackAuthenticateSuccess;
/**
 * Клик на кнопку "забыли пароль" при авторизации
 */
function trackForgotPasswordClick() {
    analytics_1.ca('event', {
        name: 'oldevent',
        category: 'AuthBlock',
        action: 'forgot_password_click',
        label: '',
    });
}
exports.trackForgotPasswordClick = trackForgotPasswordClick;
/**
 * Клик на кнопку "забыли пароль" при мердже
 */
function trackForgotPasswordClickMerge() {
    analytics_1.ca('event', {
        name: 'oldevent',
        category: 'AuthBlock',
        action: 'link_accounts_forgot_password',
        label: '',
    });
}
exports.trackForgotPasswordClickMerge = trackForgotPasswordClickMerge;
/**
 * Успешная отправка формы "забыли пароль"
 */
function trackForgotPasswordSubmitSuccess() {
    analytics_1.ca('event', {
        name: 'oldevent',
        category: 'AuthBlock',
        action: 'get_password',
        label: '',
    });
}
exports.trackForgotPasswordSubmitSuccess = trackForgotPasswordSubmitSuccess;
/**
 * Успешная регистрация
 */
function trackRegistrationSuccess(socialType) {
    analytics_1.ca('event', {
        name: 'oldevent',
        category: 'Registration',
        action: 'success',
        label: socialType || '',
    });
}
exports.trackRegistrationSuccess = trackRegistrationSuccess;
/**
 * Подписка на новости
 */
function trackWantsSubscription() {
    analytics_1.ca('event', {
        name: 'oldevent',
        category: 'Subscription',
        action: 'send',
        label: 'news',
    });
}
exports.trackWantsSubscription = trackWantsSubscription;
/**
 * Показ попапа "Отправлено письмо"
 */
function trackRegistrationDonePopup() {
    analytics_1.ca('event', {
        name: 'oldevent',
        category: 'AuthBlock',
        action: 'verify_email_popup_show',
    });
}
exports.trackRegistrationDonePopup = trackRegistrationDonePopup;
/**
 * Закрытие попапа "Отправлено письмо"
 */
function trackRegistrationDonePopupClose() {
    analytics_1.ca('event', {
        name: 'oldevent',
        category: 'AuthBlock',
        action: 'verify_email_popup_got_it',
    });
}
exports.trackRegistrationDonePopupClose = trackRegistrationDonePopupClose;
/**
 * Открытие попапа двухфакторной авторизации
 */
function trackTwoFactorPopupOpen(type) {
    analytics_1.ca('event', {
        name: 'oldevent',
        category: 'Authorization',
        action: 'Open',
        label: (type ? EVENT_TWO_FACTOR_MAPPER[type] : '') + "reg_popup",
    });
}
exports.trackTwoFactorPopupOpen = trackTwoFactorPopupOpen;
/**
 * Закрытие попапа двухфакторной авторизации
 */
function trackTwoFactorClose(type) {
    analytics_1.ca('event', {
        name: 'oldevent',
        category: 'Authorization',
        action: 'Click',
        label: (type ? EVENT_TWO_FACTOR_MAPPER[type] : '') + "close",
    });
}
exports.trackTwoFactorClose = trackTwoFactorClose;
/**
 * Открытие попапа после нескольких попыток ввода неправильного кода
 */
function trackTwoFactorAttemptsExhaustedPopupOpen(type) {
    analytics_1.ca('event', {
        name: 'oldevent',
        category: 'Authorization',
        action: 'Fail',
        label: (type ? EVENT_TWO_FACTOR_MAPPER[type] : '') + "fatal",
    });
}
exports.trackTwoFactorAttemptsExhaustedPopupOpen = trackTwoFactorAttemptsExhaustedPopupOpen;
function trackTwoFactorInvalid(type) {
    analytics_1.ca('event', {
        name: 'oldevent',
        category: 'Authorization',
        action: 'Fail',
        label: (type ? EVENT_TWO_FACTOR_MAPPER[type] : '') + "simple",
    });
}
exports.trackTwoFactorInvalid = trackTwoFactorInvalid;
function trackTwoFactorWhatForClick(type) {
    analytics_1.ca('event', {
        name: 'oldevent',
        category: 'Authorization',
        action: 'Click',
        label: (type ? EVENT_TWO_FACTOR_MAPPER[type] : '') + "what_for",
    });
}
exports.trackTwoFactorWhatForClick = trackTwoFactorWhatForClick;
function trackTwoFactorContinueClick(type) {
    analytics_1.ca('event', {
        name: 'oldevent',
        category: 'Authorization',
        action: 'Click',
        label: (type ? EVENT_TWO_FACTOR_MAPPER[type] : '') + "continue",
    });
}
exports.trackTwoFactorContinueClick = trackTwoFactorContinueClick;
function trackTwoFactorResendClick(type) {
    analytics_1.ca('event', {
        name: 'oldevent',
        category: 'Authorization',
        action: 'Click',
        label: (type ? EVENT_TWO_FACTOR_MAPPER[type] : '') + "send_again",
    });
}
exports.trackTwoFactorResendClick = trackTwoFactorResendClick;
function trackTwoFactorCannotConfirmClick(type) {
    analytics_1.ca('event', {
        name: 'oldevent',
        category: 'Authorization',
        action: 'Click',
        label: (type ? EVENT_TWO_FACTOR_MAPPER[type] : '') + "cant_confirm",
    });
}
exports.trackTwoFactorCannotConfirmClick = trackTwoFactorCannotConfirmClick;
function trackTwoFactorAttemptsExhaustedSupportClick(type) {
    analytics_1.ca('event', {
        name: 'oldevent',
        category: 'Authorization',
        action: 'Click',
        label: (type ? EVENT_TWO_FACTOR_MAPPER[type] : '') + "write_to_support",
    });
}
exports.trackTwoFactorAttemptsExhaustedSupportClick = trackTwoFactorAttemptsExhaustedSupportClick;
function trackSocialButtonClick(type) {
    analytics_1.ca('event', {
        name: 'oldevent',
        category: 'AuthBlock',
        action: 'click',
        label: type,
    });
}
exports.trackSocialButtonClick = trackSocialButtonClick;
function trackSocialAuthenticateEmailTaken() {
    analytics_1.ca('event', {
        name: 'oldevent',
        category: 'AuthBlock',
        action: 'link_accounts_show',
    });
}
exports.trackSocialAuthenticateEmailTaken = trackSocialAuthenticateEmailTaken;
function trackSocialMergeMergeClick() {
    analytics_1.ca('event', {
        name: 'oldevent',
        category: 'AuthBlock',
        action: 'link_accounts_click',
    });
}
exports.trackSocialMergeMergeClick = trackSocialMergeMergeClick;
function trackSocialMergeSucceed() {
    analytics_1.ca('event', {
        name: 'oldevent',
        category: 'Authorization',
        action: 'link_accounts_success',
    });
}
exports.trackSocialMergeSucceed = trackSocialMergeSucceed;
function trackConfirmPhoneShown() {
    analytics_1.ca('event', {
        name: 'oldevent',
        category: 'AuthBlock',
        action: 'verify_number_popup_show',
    });
}
exports.trackConfirmPhoneShown = trackConfirmPhoneShown;
function trackConfirmPhoneConfirmClick() {
    analytics_1.ca('event', {
        name: 'oldevent',
        category: 'AuthBlock',
        action: 'verify_number_popup_click',
    });
}
exports.trackConfirmPhoneConfirmClick = trackConfirmPhoneConfirmClick;
function trackConfirmPhoneResendClick() {
    analytics_1.ca('event', {
        name: 'oldevent',
        category: 'AuthBlock',
        action: 'verify_number_popup_retry',
    });
}
exports.trackConfirmPhoneResendClick = trackConfirmPhoneResendClick;
function trackConfirmPhoneSucceed() {
    analytics_1.ca('event', {
        name: 'oldevent',
        category: 'AuthBlock',
        action: 'verify_number_popup_success',
    });
}
exports.trackConfirmPhoneSucceed = trackConfirmPhoneSucceed;
function trackSocialCreateShow() {
    analytics_1.ca('event', {
        name: 'oldevent',
        category: 'AuthBlock',
        action: 'complete_reg_popup_show',
    });
}
exports.trackSocialCreateShow = trackSocialCreateShow;
/**
 * Переключение вкладок авторизация/регистрация
 */
function trackSwitchTab(label) {
    analytics_1.ca('event', {
        name: 'oldevent',
        category: 'AuthBlock',
        action: 'switch_tab',
        label: label,
    });
}
exports.trackSwitchTab = trackSwitchTab;
function trackSocialCreateCreateClick() {
    analytics_1.ca('event', {
        name: 'oldevent',
        category: 'AuthBlock',
        action: 'complete_reg_popup_click',
    });
}
exports.trackSocialCreateCreateClick = trackSocialCreateCreateClick;



//////////////////
// WEBPACK FOOTER
// ./src/shared/AuthenticationPopup/tracking.ts
// module id = 245
// module chunks = 2